export const TEMPLATE_TYPE = {
  BUMPER: 'bumper',
  ANNOUNCE: 'announce',
  BLACKOUT: 'blackout',
};

export const LAYOUT_TYPE = {
  STARTER: 'starter',
  BUMPER: 'bumper',
  ANNOUNCE: 'announcements',
  AD: 'advertising',
  BUMPER_AD: 'bumper_advertising',
  ANNOUNCE_AD: 'announcements_advertising',
  IN_CONTENT_AD: 'in_content_advertising',
  CUSTOM: 'custom',
};
